import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode } from 'swiper';



function homepage_grid() {
   const heightp = $("[data-element='home_box'] p").height();

   $( "[data-element='home_box'] p" ).each(function() {
        
        var heightp = $(this).height() + "px";
        $(this).parent().css("--heightp", heightp);
    });
}

export default homepage_grid;